import { Component, OnInit, OnDestroy, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ng2-bootstrap';
import { AppApi, EntityApi, EntityfieldApi, EntityrecordApi } from '../../../sdk/services/custom';
import { LoopBackFilter, Entity, Entityfield, Entityrecord } from '../../../sdk/models';
import { LoopBackAuth } from '../../../sdk/services/core/auth.service';
import { Observable } from 'rxjs/Rx';
import { FormBuilder, FormGroup } from "@angular/forms";
import { FormlyFieldConfig } from 'ng-formly';
import * as _ from "lodash";
import { NotificationsService } from 'angular2-notifications';
import { PlatformApp } from '../../../services/app.service';
@Component({
    selector: 'email-button',
    templateUrl: './email-button.component.html',
    providers: [EntityrecordApi, EntityApi, EntityfieldApi, AppApi],
    styleUrls: ['./email-button.component.scss']

})

export class EmailButtonComponent implements OnInit, OnDestroy {
    @Input() entityid: string;
    @Input() entityrecordid: string;
    @Input() title = '';
    @Output() onChanged: EventEmitter<Entityrecord> = new EventEmitter(true);

    filter: LoopBackFilter = <LoopBackFilter>{};
    currentuser: any;
    subscriptions: any = [];
    entityResponse = {};
    entity: Entity = new Entity();
    entityRecord: Entityrecord = new Entityrecord();
    fullEntityRecord: Entityrecord = new Entityrecord();
    entityDataFields: Array<Entityfield> = [];
    entityFormFields: Array<FormlyFieldConfig> = [];
    entityrecordtitle = '';
    entityRecordState = '';
    form: FormGroup;
    formEntityFields: any = [];
    formEntityRecord: Entityrecord = new Entityrecord();
    @ViewChild('editModal') public editModal: ModalDirective;
    notifyOptions = PlatformApp.getNotificationOptions();

    constructor(private _EntityrecordApi: EntityrecordApi, private _EntityApi: EntityApi,
        private _NotificationsService: NotificationsService, private _LoopBackAuth: LoopBackAuth, private fb: FormBuilder) {

    }

    ngOnInit(): void {
        this.currentuser = this._LoopBackAuth.getCurrentUserData();
        this.getEntityRecord();
        this.form = this.fb.group({});
    }

    getEntityRecord(): void {
        this.subscriptions.push(Observable.forkJoin(
            this._EntityrecordApi.findByIdProcessed(this.entityrecordid).map((res: Entityrecord) => res),
            this._EntityApi.getEntityDetails(this.entityid).map((res: any) => res))
            .subscribe((data) => {
                this.entityRecordState = null;
                this.entityRecord = _.cloneDeep(data[0]["response"]);
                this.entityResponse = _.cloneDeep(data[1]);
                this.entityRecord.appId = this.currentuser.appId;
                this.entity = this.entityResponse['entity'];
                this.entityDataFields = this.entityResponse['datafields'];
                this.entityFormFields = this.entityResponse['formfields'];
                this.entityrecordtitle = this.entityRecord.data[this.entity.record_name];
            }, err => this.entityRecordState = err.message));
        this.entityResponse = {};
    }

    public showEditModal(entityRecord): void {
        this.formEntityRecord = new Entityrecord();

        this.subscriptions.push(this._EntityrecordApi.findByIdforEdit(entityRecord.id)
            .subscribe((record) => {
                if (record && record['response']) {
                    if (record['response']['record'] && record['response']['record']['data']) {
                        this.formEntityRecord = _.cloneDeep(record['response']['record']['data']);
                    }
                    if (record['response']['formfields']) {
                        this.entityFormFields = record['response']['formfields'];
                    }
                    this.formEntityFields = _.cloneDeep(this.entityFormFields);

                    this.formEntityRecord.id = entityRecord.id;
                    this.editModal.show();
                } else {
                    console.log('ERROR - Loading Record ' + entityRecord.id);
                    this.notify('error', 'Record', 'Not Loaded; Please refresh');
                }
            }));
    }

    public hideEditModal(): void {
        if (this.form && this.form['subscriptions'])
            this.form['subscriptions'].forEach(s => { s.unsubscribe(); });
        if (this.form)
            this.form = this.fb.group({});
        this.editModal.hide();
    }

    ngOnDestroy() {
        for (var i = 0; i < this.subscriptions.length; i++) this.subscriptions[i].unsubscribe();
    }

    patchOrCreateEntity(formEntityRecord): void {
        var entityRecordforSave = new Entityrecord();
        entityRecordforSave.data = formEntityRecord;
        entityRecordforSave.lastupdatedby = this.currentuser.id;

        if (!formEntityRecord.id) {
            entityRecordforSave.entityId = this.entity.id;
            entityRecordforSave.createdby = this.currentuser.id;
            entityRecordforSave.appId = this.currentuser.appId;

            this.subscriptions.push(this._EntityrecordApi.patchOrCreate(entityRecordforSave)
                .subscribe((newrecord) => {
                    this.entityRecord = newrecord;
                    this.hideEditModal();
                    this.setRecord(newrecord);
                }));
        } else {

            this.subscriptions.push(this._EntityrecordApi.patchAttributes(formEntityRecord.id, entityRecordforSave)
                .subscribe((updatedrecord) => {
                    this.entityRecord = updatedrecord;
                    this.hideEditModal();
                    this.setRecord(updatedrecord);
                }));
        }

    }

    setRecord(record: Entityrecord) {
        this.onChanged.emit(record);
    }

    sendEmail(record) {

    }

    notify(type, title?, content?, options?) {
        if (!options) options = PlatformApp.getNotificationOptions();
        if (!options.id) options.id = type + '-' + title + '_' + content;
        switch (type) {
            case 'success': this._NotificationsService.success(title, content, options); break;
            case 'alert': this._NotificationsService.alert(title, content, options); break;
            case 'error': this._NotificationsService.error(title, content, options); break;
            case 'info': this._NotificationsService.info(title, content, options); break;
            case 'bare': this._NotificationsService.bare(title, content, options); break;
            default: this._NotificationsService.info(title, content, options);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/widgets/email-button/email-button.component.ts